import { Layout } from 'antd';
import * as React from 'react';

import s from './BaseHeader.module.scss';

const BaseHeader: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <Layout.Header className={s.baseHeader}>{children}</Layout.Header>;
};

export default BaseHeader;
